// a lot of old posts have content saved with links to http site rather than https
// to avoid mixed content block manually update urls when fetching
export const upgradeUrl = (url: string) => url.replace("http://", "https://");
